import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, setPosts, setPostsSearch, setSinglePost, startLoading } from '../reducers/postSlice';

export const actionFetchPosts = () => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchAllPosts
        dispatch({
            type: setPosts.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}